"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ImageLinkRenderer = (ctx) => ({
    renderV1(link) {
        return {
            type: "Link.image",
            value: {
                image: {
                    name: link.name,
                    kind: link.kind,
                    url: ctx.urlRewriter.optimizeImageUrl(link.url),
                    size: link.size,
                    height: link.height,
                    width: link.width,
                },
            },
        };
    },
    renderV2(_def, link) {
        return {
            id: link.id,
            link_type: "Media",
            name: link.name,
            kind: link.kind,
            url: ctx.urlRewriter.optimizeImageUrl(link.url),
            size: link.size,
            height: link.height,
            width: link.width,
        };
    },
    renderMocks(_def, _link) {
        return {
            link_type: "Media",
            name: "mock",
            kind: "image",
            url: "https://source.unsplash.com/random",
            size: "10kB",
            height: "1920px",
            width: "1080px",
        };
    },
});
exports.default = ImageLinkRenderer;
